import apiService from "./apiService";

const requestCampaignList = (page = 1, status, frequency, fromDate, toDate) => {
  const params = {
    page: page,
    item_per_page: 10,
  }
  if (status) {
    params.status = status
  }
  if (frequency) {
    params.frequency = frequency
  }

  if (fromDate) {
    params.from_date = `${fromDate}`
  }

  if (toDate) {
    params.to_date = `${toDate}`
  }


  return apiService.get(URIS.campaigns, {params})
}

export {requestCampaignList}

const URIS = {
  campaigns: '/v1/admin/reports/campaigns',
}